//
import type { BasePrice } from '@/types/Models/BasePrice'
import { notify } from '@kyvg/vue3-notification'
import { DEFAULT_LOADER } from '@/const/LoadersNames'
import { EDIT_PRICE_MODAL } from '@/const/ModalTypes'
import { ASSIGNMENT, CUSTOMER, SENDER_ADDRESS } from '@/const/PriceTypes'
import { none } from '@/services/Helpers'
import { openModal } from '@/services/Modal'
import { type PricesStore, usePricesStore } from '@/store/prices'
import { type UiStore, useUiStore } from '@/store/ui'
import { STAFF_ASSIGNMENTS_DETAILS, STAFF_CUSTOMERS_LIST } from '@/types/router'
import store from '@/store'
import router from '@/router'

const uiStore: UiStore = useUiStore(store.pinia)
const pricesStore: PricesStore = usePricesStore(store.pinia)

export const savePrices = async () => {
  uiStore.loaderShow({ name: DEFAULT_LOADER })

  try {
    await pricesStore.save()
    notify({ group: 'success', text: 'Prices have been updated' })
  } catch {
    notify({ group: 'error', text: 'Price update error' })
  } finally {
    uiStore.loaderHide({ name: DEFAULT_LOADER })
  }
}

export const updatePrice = (price: BasePrice) => {
  pricesStore.updatePrices(price)
}

export const addPrice = () => {
  openModal(EDIT_PRICE_MODAL)
}

export const removePrice = (price: BasePrice) => {
  openModal('confirmWrap', {
    title: 'Remove price?',
    message: 'This change will not affect already optimized assignments.',
    onConfirm: async () => {
      uiStore.loaderShow({ name: DEFAULT_LOADER })

      try {
        await pricesStore.remove(price.id)
        notify({ group: 'success', text: 'Price have been removed' })
      } catch {
        notify({ group: 'error', text: 'Price remove error' })
      } finally {
        uiStore.loaderHide({ name: DEFAULT_LOADER })
      }
    },
  })
}

export const resetEverything = () => {
  openModal('confirmWrap', {
    title: 'Reset custom prices',
    message: 'Are you sure you want to reset everything to default?',
    onConfirm: () => {
      const type = pricesStore.type
      const entityId = pricesStore.entityId
      pricesStore.reset(String(entityId ?? '')).catch(none)
      switch (type) {
        case CUSTOMER:
        case SENDER_ADDRESS:
          router.push({ name: STAFF_CUSTOMERS_LIST }).then(none)
          break
        case ASSIGNMENT:
          router.push({ name: STAFF_ASSIGNMENTS_DETAILS, params: { id: entityId } }).then(none)
          break
        default:
          break
      }
    },
  })
}
